<template>
  <div class="anchor-item" :class="{ active }">
    <div class="anchor-item-point"></div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'anchor-item',
  props: {
    active: Boolean,
  },
}
</script>
<style lang="less">
.anchor-item {
  display: flex;
  align-items: center;
  font-size: 24px;
  padding: 18px 0;
  cursor: pointer;

  color: #8d8d8d;

  &.active {
    color: #1b1b1b;
  }
  .anchor-item-point {
    opacity: 0;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background-color: #2463e7;
    transform: translateX(-7px);
    margin-right: 16px;
  }
  &.active {
    .anchor-item-point {
      opacity: 1;
    }
  }
}
</style>